'use strict';
module.exports = function(app) {
    app.controller('auctionSettingController', ['$scope', 'socket', '$state', '$timeout', 'admin', '$http', '$log', function($scope, socket, $state, $timeout, admin, $http, $log) {
        $scope.state = {};
        $scope.state.auctionSelected = false;
        $scope.state.loggedIn = false;

        $scope.auctions = [];
        socket.on('update:auctions', function(auctions) {
            $scope.auctions = auctions;
        });

        $scope.adminLogin = function (username, password) {
            $scope.state.failedLogin = false;

            socket.once('success:admin:login',function() {
                $scope.state.loggedIn = true;
                admin.setAdminAuthenticated();
            });

            socket.once('rejected:admin:login',function() {
                $scope.state.failedLogin = true;
                $scope.state.loggedIn = false;
                $scope.password = '';
            });

            socket.emit('admin:login', ''+username, ''+password);
        };

        $scope.adminImport = function (auctions_id) {
            $scope.state.failedImport = false;
            $scope.state.importing = true;

            socket.once('success:admin:import',function() {
                $scope.state.importing = false;
                $scope.state.failedImport = false;
            });

            socket.once('rejected:admin:import',function() {
                $scope.state.importing = false;
                $scope.state.failedImport = true;
            });

            socket.emit('admin:import', auctions_id);
        };

        $scope.adminReset = function (auctions_id) {
            $scope.state.failedResetReason = '';
            $scope.state.failedReset = false;
            $scope.state.importing = 2;
            socket.once('admin:reset:url',function(url) {
                $http({
                    method: 'GET',
                    url: url
                }).then(function(response) {
                    var data = (response && response.data) || {};
                    var retval = parseInt(data && data.retval, 10);
                    if(retval === 0) {
                        $scope.state.importing = 3;
                    } else {
                        $log.debug('response = '+ JSON.stringify(response, null, 2));
                        $scope.state.failedReset = true;
                        $scope.state.failedResetReason = ''+JSON.stringify(response, null, 2);
                        $log.debug('error: return status was ' + retval);
                        $scope.state.importing = 4;
                    }
                }, function(response) {
                    $scope.state.failedReset = true;
                    $scope.state.failedResetReason = ''+JSON.stringify(response, null, 2);
                    $log.debug('error: ' + JSON.stringify(response, null, 2));
                    $scope.state.importing = 5;
                });
            });
            socket.once('rejected:admin:reset',function(response) {
                $scope.state.failedReset = true;
                $scope.state.failedResetReason = ''+JSON.stringify(response, null, 2);
                $log.debug('error: ' + JSON.stringify(response, null, 2));
                $scope.state.importing = 6;
            });
            socket.emit('admin:reset');
        };

        $scope.adminSelectAuction = function(auction_id) {
            $scope.state.failedAuctionSelect = false;
            socket.once('success:admin:select:auction',function() {
                $scope.state.auctionSelected = true;
                $timeout(function(){
                    $state.go('bidding_product');
                }, 0);
            });
            socket.once('rejected:admin:select:auction',function() {
                $scope.state.failedAuctionSelect = true;
            });
            socket.emit('admin:select:auction', auction_id);
        };
    }]);
};



/*****************
 ** WEBPACK FOOTER
 ** ./bidding_product/js/controller/auction_setting.controller.js
 ** module id = 54
 ** module chunks = 0
 **/